<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">学分认定  >  学分认定指南 </div>
    </div>
    <div class="auto padding250">
       <p class="title">学分认定指南</p>
      <div class="container ">
        <p class="title">学分认定指南</p>
        <p class="tip" >无证学员和已取得证书学员统一进入此页面，已认定学分的学员可在个人中心 <router-link to='/xuefendetail'>查看认定记录。</router-link></p>
        <p >
          <router-link to="/renzheng" class="button">开始认定</router-link>
        </p>

      </div>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .title{
      font-size: 26px;
      color: #000;
      margin-top: 30px;
    }
    .container{
      background-color: #fff;
      padding: 50px 30px;
      margin-top: 10px;
      text-align: center;
      .title{
        font-size: 20px;
        color: #000;
      }
      .tip{
        font-size: 14px;
        color: #999;
        margin:50px auto 100px;


         a{
           color: #0A3C68;
         }
      }
      .button{
        margin-top: 40px;
        color: #fff;
        display: inline-block;
        width: 220px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #073C68;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'

    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {
          headers,
          footers

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/changeScore/xuefenrending.vue